import { useEffect, useState } from "react";
import { Checkbox, ListItemText, MenuItem, Select, Typography } from "@mui/material";

/**
 * Select listas su keliai pasirinkimai ir galimybe pasirinkti visus
 * @param {string} pavadinimas
 * @param {[]} grupes visu galimu pasirinkimu masyvas
 * @param {[]} pasirinktos masyvas pasirinktu
 * @param {() => {}} changeGrupes set funckija, kuri pakeicia busena
 * @param {boolean} fullWidth paduoti true, jei select listas turi uzimti visi ilgi
 * @returns
 */
const GrupiuSelectItem = ({
  pavadinimas,
  grupes,
  pasirinktos,
  changeGrupes,
  fullWidth,
  tekstas,
}) => {
  const [zymVisos, setZymVisos] = useState(true);

  useEffect(() => {
    setZymVisos(pasirinktos.length === grupes.length);
  }, [pasirinktos, grupes]);

  const handleChange = (checked, value) => {
    if (checked) {
      changeGrupes([...pasirinktos, Number(value)]);
      setZymVisos(pasirinktos.length + 1 === grupes.length);
    } else {
      changeGrupes(pasirinktos.filter((f) => f !== Number(value)));
      setZymVisos(false);
    }
  };

  const handleZymVisas = (checked) => {
    if (checked) {
      setZymVisos(true);
      changeGrupes(grupes.map((g) => Number(g.id)));
    } else {
      setZymVisos(false);
      changeGrupes([]);
    }
  };

  return (
    <>
      <Typography noWrap>{pavadinimas}</Typography>
      <Select
        id={pavadinimas}
        name={pavadinimas}
        value={pasirinktos}
        multiple
        displayEmpty
        renderValue={() =>
          zymVisos || pasirinktos.length === 0
            ? "Visos"
            : tekstas
            ? `${tekstas}: ${pasirinktos.length}`
            : `Grupių: ${pasirinktos.length}`
        }
        size="small"
        sx={{
          maxWidth: !fullWidth ? "120px" : "none",
          width: fullWidth ? "100%" : "auto",
        }}
        fullWidth={fullWidth}
      >
        <MenuItem key={0} value={0}>
          <Checkbox
            checked={zymVisos}
            value={0}
            onChange={(e) => handleZymVisas(e.target.checked)}
          />
          <ListItemText primary="Visos" />
        </MenuItem>
        {grupes.map((grupe) => (
          <MenuItem key={grupe.id} value={grupe.id}>
            <Checkbox
              checked={pasirinktos.indexOf(grupe.id) > -1 || zymVisos}
              value={grupe.id}
              onChange={(e) => handleChange(e.target.checked, e.target.value)}
            />
            <ListItemText primary={grupe.label} />
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default GrupiuSelectItem;
